// extracted by mini-css-extract-plugin
module.exports = {"notificationsBase":"style_notificationsBase__0DlT0"};